// src/Components/Footer.js
import React, { useEffect, useState } from "react";

function Footer() {
  const [currentDate, setCurrentDate] = useState(new Date().toGMTString());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date().toGMTString());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-date">{currentDate}</div>
      </div>
    </footer>
  );
}

export default Footer;
